module.exports = __webpack_public_path__ + "files/78c9d7fdc8adaad654c16ddb9cd2f575.png";